/* jshint ignore:start */

var ReflexionaManager = (function($) {

    var instance;

    function init() {



        function initFilter()
        {
            var $reflexionaFilterBtn = $('.js-filter-reflexiona-btn');
            $reflexionaFilterBtn.on('click', function(e) {
                e.preventDefault();

                $('.js-reflexiona-form').submit();

            });
        }

        return {

            init: function() {
                var reflexionaFilter = $('.js-reflexiona-form');

                if (reflexionaFilter.length) {
                    initFilter();
                }
            }
        };
    }


    return {

        getInstance: function() {

            if (!instance) {
                instance = init();
            }

            return instance;
        }
    };
})(jQuery);
/* jshint ignore:end */
